import React, { useEffect, useRef } from "react";

export default function Iyzico3DSModal({ open, onClose, htmlContent }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    if (!iframeRef.current) return;

    iframeRef.current.srcdoc = `
      <!DOCTYPE html>
      <html>
        <head><meta charset="utf-8" /></head>
        <body style="margin:0;padding:0;">
          ${htmlContent || ""}
        </body>
      </html>
    `;
  }, [open, htmlContent]);

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: 420,
          maxWidth: "95vw",
          height: 600,
          background: "#fff",
          borderRadius: 8,
          overflow: "hidden",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: 10,
            top: 6,
            border: "none",
            background: "transparent",
            fontSize: 22,
            cursor: "pointer",
            zIndex: 10,
          }}
          aria-label="Kapat"
        >
          ×
        </button>

        <iframe
          ref={iframeRef}
          title="iyzico-3ds"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </div>
    </div>
  );
}